import arrow from '../../assets/images/solution/arrow.png'

import NetworkSafety from './NetworkSafety'
import SmartPolicing from './SmartPolicing'
import SmartGovernment from './SmartGovernment'
import SmartCommunity from './SmartCommunity'
import SmartComprehensiveInsurance from './SmartComprehensiveInsurance'
import SmartAntiSmuggling from './SmartAntiSmuggling'
import DigitalTransformation from './DigitalTransformation'

import styles from './index.module.scss'
import { useEffect, useState } from 'react'

import { urlParams } from 'utils/urlParams';
import { useHistory } from 'react-router-dom'

function Solution() {
    const [module, setModule] = useState('');

    const history = useHistory();

    useEffect(() => {
        setModule(urlParams.getUrlParams('module'));
    }, [])

    useEffect(() => {
        const unlisten = history.listen((historyLocation) => {
            setModule(urlParams.getUrlParams('module'));
        })
        return () => {
            unlisten();
        }
    }, [history]);

    const seeDetail = (type) => {
        window.open(`${window.location.origin}/solution?module=${type}`, '_blank')
    }

    return module === 'NetworkSafety' ? (
      <NetworkSafety />
    ) : module === 'SmartPolicing' ? (
      <SmartPolicing />
    ) : module === 'SmartGovernment' ? (
      <SmartGovernment />
    ) : module === 'SmartCommunity' ? (
      <SmartCommunity />
    ) : module === 'SmartComprehensiveInsurance' ? (
      <SmartComprehensiveInsurance />
    ) : module === 'SmartAntiSmuggling' ? (
      <SmartAntiSmuggling />
    ) : module === 'DigitalTransformation' ? (
      <DigitalTransformation />
    ) : (
      <div className={styles['solution-wrapper']}>
        <div className={styles['banner']}>
          <div className={styles['title']}>解决方案</div>
          <div className={styles['content']}>
            打造全方位大数据解决方案，推动行业数字化转型，实现“智慧城市”建设蓝图。
          </div>
        </div>
        <div className={styles['solution-content']}>
          <p>全部解决方案</p>
          <div className={styles['solution-container']}>
            <div className={styles['solution-left']}>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  网络安全
                </span>
                <p>
                  通过各类感知设备搭载人工智能、大数据技术，打造多维感知、立体防控的智能感知系列解决方案
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() => seeDetail('NetworkSafety')}
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  智慧警务
                </span>
                <p>
                  构建集强大计算能力、海量资源整合、高度信息共享、智能应用服务、严密安全保障、警务运行支撑“六大体系”于一体的全栈解决方案
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() => seeDetail('SmartPolicing')}
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  智慧政务
                </span>
                <p>
                  政务大数据平台、一网统管城市运行中心、公共卫生应急处置平台、政务一体化服务平台等一系列解决方案
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() =>
                    seeDetail('SmartGovernment')
                  }
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  智慧社区
                </span>
                <p>
                  覆盖物业管理、产量情况、人员出入、户籍迁移等一站式社区管理平台
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() =>
                    seeDetail('SmartCommunity')
                  }
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  智慧综保
                </span>
                <p>
                  率先打造全国智慧综保区建设试点，成为建设智慧园区的先行者
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() =>
                    seeDetail('SmartComprehensiveInsurance')
                  }
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
              <div className={styles['solution-item']}>
                <span className={styles['title']}>
                  企业数字化转型
                </span>
                <p>
                  烽火星空运用云计算、大数据技术构建集采购、生产、营销、人力、财务等一体的数字化管理解决方案，助力企业管理者掌控日常运营全景，推动组织创新、协同办公，提升核心竞争力
                </p>
                <div
                  className={styles['see-detail']}
                  onClick={() =>
                    seeDetail('DigitalTransformation')
                  }
                >
                  <span>查看详情</span>
                  <img src={arrow} alt="" />
                </div>
              </div>
            </div>
            {/* <div className="solution-right">
                                                <div className={styles['solution-item']}>
                                                    <span className={styles['title']}>企业数字化转型</span>
                                                    <p>烽火星空运用云计算、大数据技术构建集采购、生产、营销、人力、财务等一体的数字化管理解决方案，助力企业管理者掌控日常运营全景，推动组织创新、协同办公，提升核心竞争力</p>
                                                    <div className={styles['see-detail']} onClick={() => seeDetail('DigitalTransformation')}><span>查看详情</span><img src={arrow} alt="" /></div>
                                                </div>
                                            </div> */}
          </div>
        </div>
      </div>
    )
}

export default Solution